export default "__VITE_ASSET__FNLGzbgl__"